import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import AccountingEntriesGroup, {
  newAccountingEntryGroup,
} from "../../models/accounting-entries-group";
import AccountingEntriesGroupForm from "./AccountingEntriesGroupForm";

interface AccountingEntriesGroupUpdateModalProps {
  show: boolean;
  accountingEntriesGroup?: AccountingEntriesGroup;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const AccountingEntriesGroupUpdateModal: React.FC<
  AccountingEntriesGroupUpdateModalProps
> = ({ show, accountingEntriesGroup, onCancel, onSuccess }) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialAccountingEntriesGroup, setInitialAccountingEntriesGroup] =
    useState<AccountingEntriesGroup>(
      accountingEntriesGroup
        ? accountingEntriesGroup
        : newAccountingEntryGroup()
    );

  const modalTitle = accountingEntriesGroup
    ? `Editar Asiento Contable N°: ${accountingEntriesGroup.id}`
    : `Crear Asiento Contable Nuevo`;

  const onClose = () => {
    setInitialErrors({});
    setInitialAccountingEntriesGroup(newAccountingEntryGroup());
    onCancel();
  };
  useEffect(() => {
    setInitialAccountingEntriesGroup(
      accountingEntriesGroup
        ? accountingEntriesGroup
        : newAccountingEntryGroup()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountingEntriesGroup]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <AccountingEntriesGroupForm
            initialAccountingEntriesGroup={initialAccountingEntriesGroup}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default AccountingEntriesGroupUpdateModal;
